import { defineNuxtPlugin } from "nuxt/app";
import { gettext } from "@/services/translation";

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(gettext);
});
